<template>
    <div class="package">
        <!-- <pre>{{objPack}}</pre> -->
        <div class="box-white-wrapper" v-if="objPack.customer.length > 0">
            
            <div class="timeline">
                <div class="status-delivery" v-if="!portrait">
                    <template  v-for="(status, index) in statusPackages">
                        <div  :class="['item',{'wait': objPack.package.st01Code < status.id}]" :key="index" v-if="status.timeLine == 1">
                            <div class="icon">
                                <img :src="require(`@/assets/images/deliveries/${status.id}.png`)" />
                            </div>
                            <p>{{status.name}}</p>
                        </div>
                    </template>
                    <div class="line"></div>
                </div>
                <div class="current-status" v-if="portrait">
                    <div  class="item">
                        <div class="icon">
                            <img :src="require(`@/assets/images/deliveries/${objPack.package.st01Code}.png`)" />
                        </div>
                        <p>Estado: <strong>{{objPack.package.statusname}}</strong></p>
                    </div>
                </div>
            </div>
            
            <div class="wrap-box">
                
                <a :href="factAPI +''+ objPack.package.invoiced" target="_blank" 
                    class="viewBill" v-if="objPack.package.invoiced != null && userInfoData.role !== Roles.Customer">Ver Factura</a>
            
                <div class="item">
                        <div class="head">
                            <div class="icon">
                                <img src="@/assets/images/package.png" alt="" class="img-fluid">
                            </div>
                            <div class="subTitle">
                                <div class="option-stars survey-list">
                                    <template v-for="star in [1,2,3,4,5]">
                                        <feather :key="star" :class="{'active': star <= objPack.survey?.answer}" type="star"></feather>
                                    </template>
                                </div>
                                Información del paquete
                                <span class="no-rating-reason" v-if="!objPack.survey?.answer && objPack.survey?.reason">Motivo de no calificación: {{ reasonText(objPack.survey.reason) }}</span>
                                <a href="javascript:void(0)" class="rate-service" @click="openModalSurvey()" v-if="!objPack.survey?.answer">Calificar servicio</a>
                            </div>
                        </div>
                        <div class="detail">
                            <h3>Fecha registro:</h3>
                            <p>{{ objPack.package.createdAt | moment('DD/MM/YYYY') }}</p>
                        </div>
                        <div class="detail">
                            <h3>Nro Tracking:</h3>
                            <p>{{ objPack.package.tracking }}</p>
                        </div>
                        <div class="detail">
                            <h3>Nro Orden:</h3>
                            <p>{{ objPack.package.guide }}</p>
                        </div>
                        <div class="detail">
                            <h3>Producto:</h3>
                            <p v-if="objPack.tax != undefined">{{objPack.tax.name}}</p>
                        </div>
                        <div class="detail">
                            <h3>Precio del producto:</h3>
                            <p v-if="objPack.package.price != null">$ {{ formatNumber(objPack.package.price)}}</p>
                        </div>
                        <div class="detail">
                            <h3>Peso:</h3>
                            <p>{{ objPack.package.weight }} lbs</p>
                        </div>
                        <div class="detail">
                            <h3>Costo:</h3>
                            <p v-if="objPack.package.costototal != null">$ {{ formatNumber(objPack.package.costototal)}}</p>
                        </div>
                        <div class="detail">
                            <h3>Adjunto:</h3>
                            <p v-if="objPack.package.url" @click="showSingle(objPack.package.url)">Visualizar <feather type="eye"/></p>
                            <p v-if="!objPack.package.url">Sin adjunto</p>
                        </div>
                        <div class="detail address">
                            <h3>Observaciones</h3>
                            <p>{{ objPack.package.comments }}</p>
                        </div>
                        <div class="detail" v-if="objPack.survey?.signature">
                            <div class="signature">
                                <img :src="objPack.survey.signature" alt="">
                            </div>
                        </div>
                </div>

                <div class="item">
                        <div class="head">
                            <div class="icon">
                                <vs-avatar :src="objPack.customer[0].profileUrl" size="70px"/>
                            </div>
                            <div class="subTitle">Información del cliente</div>
                        </div>
                        <div class="detail">
                            <h3>Casillero</h3>
                            <p>{{ objPack.customer[0].typename }}</p>
                        </div>
                        <div class="detail">
                            <h3>Nombre</h3>
                            <p><router-link :to="`/customers/${objPack.customer[0].id}`">{{ objPack.customer[0].firstName + " " + objPack.customer[0].lastName}}</router-link></p>
                        </div>
                        <div class="detail">
                            <h3>Cédula o pasaporte:</h3>
                            <p>{{ objPack.customer[0].identification }}</p>
                        </div>
                        <div class="detail">
                            <h3>Email:</h3>
                            <p>{{ objPack.customer[0].email }}</p>
                        </div>
                        <div class="detail">
                            <h3>Teléfono:</h3>
                            <p>{{ objPack.customer[0].mobile +' / '+ objPack.customer[0].phone}}</p>
                        </div>
                        <div class="detail">
                            <h3>Notificar:</h3>
                            <p>Whatsap, llamada</p>
                        </div>
                        <div class="detail">
                            <h3>Entrega</h3>
                            <p>{{ objPack.customer[0].dlvName }}</p>
                        </div>
                        <div class="detail">
                            <h3>Dirección:</h3>
                            <p>{{ objPack.customer[0].pvname +', '+ objPack.customer[0].ctname +', '+objPack.customer[0].dtname }}</p>
                        </div>
                        <div class="detail address">
                            <h3>Otras señas</h3>
                            <p>{{ objPack.customer[0].address }}</p>
                        </div>
                </div>

            </div>

            <div class="d-flex justify-between">
                <div class="infoPreAlerta" v-if="userInfoData.role !== Roles.Customer">
                    <p>¿La información del paquete se encuentra completa?</p>
                    <vs-switch v-model="preAlerted" color="success" @change="changePrealerted"/>
                </div>

                <div class="infoPreAlerta" v-if="userInfoData.role !== Roles.Customer">
                    <p>¿Desea agregar seguimiento a este paquete?</p>
                    <vs-switch v-model="followUp" color="success" @change="changeFollowUp"/>
                </div>
            </div>
            
            <vs-tabs alignment="left" position="top" class="extended" v-model="tabIndex">
                <vs-tab icon="assignment" label="Historial">
                    <vs-table :data="objPack.changes" max-items="15">
                        <template slot="header">
                            <vs-button class="flex-end" @click="changePackageStatus()" color="primary" type="border" icon="refresh" v-if="userInfoData.role !== Roles.Customer">Actualizar Estado</vs-button>
                        </template>
                        <template slot="thead">
                            <vs-th sort-key="fecha"> Fecha</vs-th>
                            <vs-th sort-key="username" v-if="userInfoData.role === Roles.Admin"> Agente</vs-th>
                            <vs-th sort-key="statuscode" class="w-180"> Estado </vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].created">
                                    {{data[indextr].fecha | moment('DD/MM/YYYY hh:mm:ss')}}
                                </vs-td>
                                <vs-td :data="data[indextr].username" v-if="userInfoData.role === Roles.Admin">
                                        {{data[indextr].username}}
                                </vs-td>
                                <vs-td :data="data[indextr].name">
                                    <span :class="`status status-${data[indextr].statuscode}`">
                                        {{data[indextr].statusname}}
                                    </span>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab icon="attach_money" label="Detalle facturación" v-if="userInfoData.role === Roles.Admin">
                    <vs-alert title="Información" active="true" v-if="objPack.package.costototal == null || billError">
                        {{ billMessage }}
                    </vs-alert>
                    <div class="tab-info" v-if="objPack.package.costototal != null">
                        <vs-table :data="objPack.detail" max-items="15">
                            <template slot="header" v-if="objPack.package.finalized != 1">
                                <vs-button class="flex-end vs-con-loading__container" color="primary" type="border" v-if="!billError" 
                                    id="btnBilled" icon="check_circle" @click="modalBillActive = !modalBillActive">Enviar a facturación</vs-button>
                            </template>
                            <template slot="thead">
                                <vs-th sort-key="description"> Descripción </vs-th>
                                <vs-th sort-key="amount">Monto($) </vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].description">
                                        {{data[indextr].description}}
                                    </vs-td>
                                    <vs-td :data="data[indextr].amount">
                                        USD {{ formatNumber(data[indextr].amount)}}
                                        <span class="edit-otherCost" v-if="data[indextr].co01Code > 3 && objPack.package.finalized != 1">
                                            <feather type="edit-2" @click="openCostoModal(formatNumber(data[indextr].amount), data[indextr].co01Code)"/>
                                        </span>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div> 
                </vs-tab>
                <vs-tab icon="speaker_notes" label="Notas">
                    <div class="tab-info notes">
                        <vs-table :data="objPack.notes" max-items="15" :key="key">
                            <template slot="header" v-if="userInfoData.role === Roles.Admin">
                                <vs-button class="flex-end vs-con-loading__container" color="primary" type="border" 
                                    id="btnBilled" icon="message" @click="activeNewNote = true">Crear nota</vs-button>
                            </template>
                            <template slot="thead">
                                <vs-th sort-key="note"> Descripción </vs-th>
                                <vs-th sort-key="createdAt"> Fecha </vs-th>
                                <vs-th v-if="userInfoData.role === Roles.Admin"></vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].note">
                                        {{data[indextr].note}}
                                    </vs-td>
                                    <vs-td :data="data[indextr].createdAt">
                                        {{data[indextr].createdAt | moment('DD/MM/YYYY hh:mm:ss')}}
                                    </vs-td>
                                    <vs-td class="options" v-if="userInfoData.role === Roles.Admin">
                                        <span class="opt" @click="editNote(indextr)"><feather type="edit"/></span>
                                        <span class="opt" @click="removeNote(indextr)"><feather type="trash-2"/></span>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div> 
                </vs-tab>
                <vs-tab class="preAlert" icon="settings" label="Ajustes" v-if="canEdit">
                    <a href="javascript:void(0)" class="removePackage" @click="deletePackageDialog()">Eliminar preAlerta</a>
                    <form-wizard :color="color" error-color="#e74c3c" title="" ref="wizard" subtitle="">
                        <tab-content title="Datos del paquete" :before-change="validateFirstStep">
                            <div class="group">
                                <div :class="['form-input',{'has-error': $v.pack.tracking.$error }]">
                                    <vs-input label="Número de tracking" v-model.trim="$v.pack.tracking.$model"/>
                                    <span class="error-text" v-if="$v.pack.tracking.$error"><feather type="info" />Este campo es requerido</span>
                                </div>
                                <div :class="['form-input',{'has-error': $v.pack.guide.$error }]">
                                    <vs-input label="Número de orden" v-model.trim="$v.pack.guide.$model"/>
                                    <span class="error-text" v-if="$v.pack.guide.$error"><feather type="info" />Este campo es requerido</span>
                                </div>
                            </div>
                            <div :class="['form-input',{'has-error': $v.pack.tax.$error }]">
                                <label class="vs-input--label">Producto <small class="needPermission" v-if="pack.tax.permission == 1">(requiere permiso)</small></label>
                                <select-input :options="products" v-model="$v.pack.tax.$model"></select-input>
                                <span class="error-text" v-if="$v.pack.tax.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div class="group">
                                <div :class="['form-input',{'has-error': $v.pack.weight.$error }]">
                                    <vs-input label="Peso" v-model.trim="$v.pack.weight.$model" @keypress="isNumber($event)"/>
                                    <span class="error-text" v-if="$v.pack.weight.$error"><feather type="info" />Este campo es requerido</span>
                                </div>
                                <div :class="['form-input',{'has-error': !$v.pack.price.required }, {'has-error': !$v.pack.price.minValue }]">
                                    <vs-input label="Precio (USD)" v-model.trim="$v.pack.price.$model" @keypress="isNumber($event)"/>
                                    <span class="error-text" v-if="!$v.pack.price.required && $v.pack.price.$error"><feather type="info" />Este campo es requerido</span>
                                    <span class="error-text" v-if="!$v.pack.price.minValue && $v.pack.price.required"><feather type="info" />El valor debe ser numérico</span>
                                </div>
                            </div>
                        </tab-content>
                        <tab-content title="Información adicional" :before-change="validStepTwoForm">
                            <div class="aditionalInfo">
                                <div :class="['wrap-upload',{'border-error': $v.pack.resource.$error }]">
                                    <div class="preview" v-if="pack.resource != '' && pack.resource != null" @click="popupActivo4=true">
                                        <img :src="checkExtension(pack.resource)" alt="">
                                    </div>
                                    <div class="attach" @click="popupActivo4=true" v-if="pack.resource == '' || pack.resource == null">
                                        Adjuntar factura
                                        <img src="@/assets/images/uploadFile.png" alt="">
                                    </div>
                                    <span class="removeInvoice" v-if="pack.resource != '' && pack.resource != null" @click="removeResource()"><feather type="x-circle" /></span>
                                </div>
                                <div class="detail">
                                    <div class="group">
                                        <div :class="['form-input',{'has-error': $v.pack.delivery.$error }]">
                                            <label class="vs-input--label">Lugar de Retiro</label>
                                            <select-input :options="deliveries" v-model="$v.pack.delivery.$model"></select-input>
                                            <span class="error-text" v-if="$v.pack.delivery.$error"><feather type="info" />Este campo es requerido</span>
                                        </div>
                                    </div>
                                    <div class="group">
                                        <div class="form-input">
                                            <vs-input label="Comentarios" v-model.trim="pack.comments" placeholder="Favor indicarnos la tienda donde realizaste la compra"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab-content>
                        <tab-content title="Resumen" >
                            <div class="wrp-boxes">
                                <div class="box" v-if="costs.length > 0">
                                    <div class="head">
                                        <div class="icon">
                                            <img src="@/assets/images/box-open.svg" alt="">
                                        </div>
                                        <div class="title">El costo de tu pre alerta es de:</div>
                                    </div>
                                    <div class="cost"><p>${{ formatNumber(totalCost) }}</p></div>
                                    <div class="detail"> 
                                        <!-- <div class="item">Precio del producto <span>${{formatNumber(pack.price)}}</span></div>  -->
                                        <div class="item">Precio del transporte<span>${{formatNumber(costs[0].amount)}}</span></div> 
                                        <!-- <div class="item">Protección <span>${{formatNumber(costs[1].amount)}}</span></div>  -->
                                        <div class="item">Impuesto de aduana<span>${{formatNumber(totalTax)}}</span></div> 
                                        <div class="item" v-if="pack.tax.permission == 1">Permiso PROCOMER<span>${{formatNumber(pack.tax.permissionCost)}}</span></div> 
                                        <div class="item">Total<span>${{  formatNumber(totalCost) }}</span></div>
                                    </div>
                                    <vs-button color="primary" type="border" icon="" id="btnPaid" class="vs-con-loading__container" @click="updatePackageCost">Actualizar Paquete</vs-button>
                                </div>
                            </div>
                        </tab-content>
                        <template slot="footer" slot-scope="props">
                            <div class="wizard-footer-left">
                                <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" :style="props.fillButtonStyle">Atras</wizard-button>
                            </div>
                            <div class="wizard-footer-right">
                                <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Siguiente</wizard-button>
                            </div>
                        </template>
                    </form-wizard>
                </vs-tab>
            </vs-tabs>
        </div>
        <modalBasic :show="showModalChangeWeigth">
            <div class="modal-header" slot="modal-header">¡Información!</div>
            <div class="modal-body p-50-40" slot="modal-body">
            </div>
            <div class="modal-footer" slot="modal-footer">
                <vs-button color="danger" type="border" icon="block" @click="showModalChangeWeigth = false">No, Cancelar</vs-button>
                <vs-button id="btnConfirm" color="success" type="border" icon="check" 
                :disabled="confirmStatus" class="vs-con-loading__container" @click="josue()">Si, Actualizar</vs-button>
            </div> 
        </modalBasic>
        <modalPackage @modal-event="handleActionModalPackage" :packID="packageId" :selected="pkgCurrentStatus" :show="modalActive"></modalPackage>
        <modal-survey @modal-event="handleActionModalSurvey" :packID="packageId" :customer="objPack.customer[0].id"
            :show-signature="false" :show="modalActiveSurvey" v-if="objPack.customer.length > 0"></modal-survey>
        <vue-easy-lightbox escDisabled :moveDisabled="false" :visible="visible" :imgs="imgs" @hide="handleHide"></vue-easy-lightbox>
        <vs-prompt title="Agregar Nota" accept-text="Aceptar" cancel-text="Cancelar"
          @accept="createNewNote"
          @close="closedModalNote"
          @cancel="closedModalNote" color=""
          :is-valid="notes != ''"
          :active="activeNewNote" :buttons-hidden="buttonsHidden">
          <div class="modalNewNote form">
            <vs-textarea :maxlength="maxlength" :counter="maxlength" :counter-danger.sync="counterDanger" v-model="notes" />
            <div class="notifyNote">Notificar por correo: <vs-switch v-model="notifyNote" color="success"/></div>
            <br v-if="buttonsHidden">
            <p v-if="buttonsHidden">Procesando.. Espero un momento</p>
          </div>
        </vs-prompt>
        <vs-prompt title="Ajuste de cargos" accept-text="Aceptar" cancel-text="Cancelar"
          @accept="updateOtherCosts"
          @close="closedModalCost"
          @cancel="closedModalCost" color=""
          :is-valid="tempCost != ''"
          :active="activeOtherCost" :buttons-hidden="buttonsHidden">
          <div class="modalNewNote form">
            <vs-input v-model="tempCost" @keypress="isNumber($event)"/>
            <br v-if="buttonsHidden">
            <p v-if="buttonsHidden">Procesando.. Espero un momento</p>
          </div>
        </vs-prompt>
        
        <vs-popup class="media-wrapper" fullscreen title="Factura de compra" :active.sync="popupActivo4">
            <vs-tabs>
                <vs-tab label="Galería">
                    <div class="media-content">
                        <div :class="['gallery', { w100: resourceSelected === 0}]">
                            <div class="wrrapper">
                                <template v-for="(image, index) in resources">
                                    <div :key="`s-${index}`" :class="['sigle-image', {active: resourceSelected.id === image.id}]">
                                      <img :src="checkExtension(image.url)" alt="" @click="findResource(image.id, index)">
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="gallery-sidebar" v-if="resourceSelected !== 0">
                            <div class="detail">
                                <div class="title">Factura</div>
                                <div class="feature">
                                    <a :href="resourceSelected.url" target="_blank">
                                        <img :src="checkExtension(resourceSelected.url)"/>
                                    </a>
                                </div>
                                <div class="actions">
                                    <vs-button color="success" type="border" icon="check" @click="closeModalResource">Seleccionar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                
                <vs-tab label="Subir Factura">
                    <div class="dropzone-wrapper">
                        <vue-dropzone :options="dropzoneOpts" id="upload-images"
                            v-on:vdropzone-success="successUploaded" v-on:vdropzone-sending="sendingBeforeDropzone"> </vue-dropzone>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vs-popup>

        <modalSendToBill @modal-event="handleBillModal" :packID="packageId"  :options="paymentWays" 
            :customer="objPack.customer[0].id" :show="modalBillActive" v-if="objPack.customer.length > 0"></modalSendToBill>
        
        
        <modalBasic :show="showEditModal">
            <div class="modal-header" slot="modal-header">Editar Nota</div>
            <div class="modal-body p-50-40" slot="modal-body">
                <vs-textarea v-model="objNote.note"></vs-textarea>
            </div>
            <div class="modal-footer" slot="modal-footer">
                <vs-button color="danger" type="border" icon="block" @click="showEditModal = false">Cancelar</vs-button>
                <vs-button id="btnConfirm" color="success" type="border" icon="check" 
                :disabled="statusEditNote || objNote.note == ''" class="vs-con-loading__container" @click="saveEditNote()">Si, Actualizar</vs-button>
            </div> 
        </modalBasic>

    </div>
</template>
<script>
import { mapState, } from 'vuex'
import Http  from '@/helpers/Http.js'
import {helper} from '@/helpers/utils'
import vueDropzone from 'vue2-dropzone'
import { Role } from '@/helpers/Role.js'
import VueEasyLightbox from 'vue-easy-lightbox'
import PackageModel from "@/models/PackageModel"
import { required, minValue} from 'vuelidate/lib/validators'
import modalBasic from '@/components/Modal/Basic.vue'
import TaxDataService from "@/services/TaxDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import PackageDataService from "@/services/PackageDataService"
import ModalPackage from '@/components/Modal/PackageStatus.vue'
import ModalSurvey from '@/components/Modal/UserSurvey.vue'
import modalSendToBill from '@/views/Packages/Components/Bill.vue'
import ClientDataService from "@/services/ClientDataService"
import ResourceDataService from "@/services/ResourceDataService"
import { SurveyReasons } from "@/helpers/SurveyReasons"

export default {
  name: "Package",
  mixins: [helper],
  components: {
    modalBasic,
    VueEasyLightbox,
    ModalPackage,
    ModalSurvey,
    modalSendToBill,
    SelectInput,
    vueDropzone
  },
  data () {
    return {
      popupActivo4:false,
      resourceSelected: 0,
      preAlerted: false,
      followUp: false,
      factAPI: 'https://boxlogistics.facturamh.com/facturas/',
      portrait: false,
      tabIndex: 0,
      deliveries: [],
      statusPackages:[],
      showModalChangeWeigth: false,
      visible: false,
      packageId: "",
      pkgCurrentStatus:{},
      modalActive: false,
      modalActiveSurvey: false,
      imgs: '',  // Img Url , string or Array of string
      history: [],
      message: '',
      packages: [],
      activeNewNote: false,
      notes: "",
      notifyNote: false,
      maxlength: 1000,
      counterDanger: false,
      buttonsHidden: false,
      totalCost: 0,
      objPack:{
        changes: [],
        detail: [],
        customer:[],  
        package:{  
          st01Code: 0
        }
      },
      confirmStatus: false,
      costs:[],
      Roles:{},
      products: [],
      pack: new PackageModel(),
      title: "",
      subtitle: "",  
      color: '#1a426d',
      canEdit: false,
      totalTax:0,
      otherCost: 0,
      tempCost: 0,
      otherTaxes:0,
      typeOtherAction: 0,
      activeOtherCost: false,
      modalBillActive: false,
      paymentWays: [
          {
              code: 1,
              name: "Contado"
          }
      ],
      resources:[],
      billError: false,
      billMessage: "Lo sentimos, para poder enviar a facturar este paquete, debes generar los costos del servicio.",
      showEditModal: false,
      statusEditNote: false,
      objNote: {},
      idxUpdateNote: "",
      key: 1

    }
  },
  validations: {
    pack:{
        id: { required },
        tracking: { required },
        guide:    { required },
        tax:      { required },
        price:    { required, minValue: minValue(0) },
        unit:     { required },
        weight:   { required },
        resource: { required },
        delivery: { required },
    },
  },
  watch: {
    windowWidth () { this.checkWidthScreen() }
  },
  computed: {
    windowWidth () { return this.$store.state.windowWidth },
    ...mapState([
      'userInfoData'
    ]),
    dropzoneOpts() {
       return {
            url: Http.defaultApi + '/files/upload',
            thumbnailWidth: 150,
            maxFilesize: 5,
            method: "POST",
            withCredentials: false,
            acceptedFiles: ".jpg,.jpeg,.png,.gif,.mp4, .pdf",
            headers: { 
            'Access-Control-Allow-Origin': '*',
            'authorization':  this.userInfoData.boxkey,
            'x-access-token': this.userInfoData.boxkey
            }
       };
    }
  },
  created(){
    this.Roles = Role
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.retrieveStatus()
    this.retrieveTaxes()
    this.retrievePackage(this.$route.params.id)
    this.checkWidthScreen()
    this.retrieveLocationsDelivery()
    this.retrieveResources()
  },
  methods: {
    reasonText(code) {
      let _found = SurveyReasons.find((item) => item.value === code);
      return _found ? _found.text : code;
    },
    retrieveResources() {
        ResourceDataService.getFiles('Invoice')
        .then(response => {
            console.log('RE',response.data)
            this.resources = response.data
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los archivos!',color:'danger',icon:'error_outline'})
        });
    }, 
    insideGAM(){
       let flag = false
       if( this.userInfoData.customer.GAM == 1 && this.pack.delivery.code == 1 ) {
           flag = true
       } 
       return flag;
    },
    successUploaded (file, response) {
        console.log('File', file);
        if(response.url !== ''){
            this.resources.push(response.obj)
            this.pack.resource = response.url+"?v="+this.getRandomNumber();
            this.popupActivo4 = false
        }
    },
    sendingBeforeDropzone (file, xhr, formData) {
        console.log('DEBUG: formData BEFORE ' + formData)
        formData.append('fileName', this.pack.tracking);
        formData.append('type', 'Invoice');
        formData.append('customer', this.assignTo == true ? this.customer.id : null);
    },    
    retrieveLocationsDelivery() {
        ClientDataService.getLocationsDelivery()
        .then(response => {
            this.deliveries = response.data
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los lugares de entrega!',color:'danger',icon:'error_outline'})
        });
    },
    allowEdit(){
      
      if(this.userInfoData.role === this.Roles.Admin && this.pack.finalized != 1){
        this.canEdit = true
      }
      if(this.userInfoData.role === this.Roles.Customer 
        && this.pack.status.id < 4){
        this.canEdit = true
      }

        
    },
    handleBillModal(response){
      if(response.error !=  undefined){
        if(!response.error){
            console.log(response);        
            this.objPack.package.finalized = 1
            this.pack.finalized = 1    
            this.$vs.notify({title:'Información!',text:'El paquete fue ha enviado a facturación.',color:'success',icon:'check'})
        }else{  
            this.billError = true
            this.billMessage =response.message.response.data.message +" El crédito disponible es de: USD " + this.formatNumber(response.message.response.data.limitAv)
            this.$vs.notify({title:'Información!',text:'Error asignado este paquete como facturado.',color:'danger',icon:'error_outline'})  
        }
      }
      this.modalBillActive = response.active
    },
    handleActionModalPackage(response){
      if(response.error !=  undefined){
        if(!response.error){
            console.log(response);
            this.objPack.package.st01Code = response.response.id
            this.objPack.package.status    = response.response
            this.retrievePackage(this.objPack.package.id)
            this.$vs.notify({title:'Información!',text:'El estado del paquete fue modificado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el estado del paquete',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActive = response.active
      
    },
    changePackageStatus(){
      this.packageId   =  this.objPack.package.id
      this.pkgCurrentStatus = { id: this.objPack.package.st01Code, name: this.objPack.package.statusname}
      this.modalActive = true
    },
    openModalSurvey(){
      this.packageId = this.objPack.package.id
      this.modalActiveSurvey = true
    },
    handleActionModalSurvey(response){
      if(response.error != undefined){
        if(!response.error){
            this.retrievePackage(this.objPack.package.id)
            this.$vs.notify({title:'Información!',text:'¡Gracias por calificar nuestro servicio!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error guardando la calificación',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActiveSurvey = response.active
    },
    handleHide() {
      this.visible = false
    },
    showSingle(url) {
        console.log(url)
      if(this.isPdf(url)){
        window.open(url);
      }else{
        this.imgs = url
        this.visible = true    
      }      
    },
    retrievePackage(id) {
        PackageDataService.get(id)
        .then(response => {
            this.objPack     = response.data;
            this.pack.unit   = {code: 'lb', name: "Libras"}
            this.pack.tax    = this.objPack.tax
            this.pack.id     = this.objPack.package.id
            this.pack.guide  = this.objPack.package.guide
            this.pack.price  = this.objPack.package.price
            this.pack.weight = this.objPack.package.weight
            this.pack.tracking = this.objPack.package.tracking
            this.pack.customerId = this.objPack.customer[0].id
            this.pack.finalized  = this.objPack.package.finalized
            this.pack.status    = { id: this.objPack.package.st01Code, name: this.objPack.package.statusname} 
            this.pack.resource  = this.objPack.package.url
            this.pack.comments  = this.objPack.package.comments 
            this.pack.delivery  = { code: this.objPack.package.dvcode, name: this.objPack.package.dvdesc }
            
            this.preAlerted     = this.objPack.package.prealerted == 1 ? true : false
            this.followUp       = this.objPack.package.followUp == 1 ? true : false
            this.packageId   =  this.objPack.package.id
            if(this.objPack.customer[0].credit > 0){
                this.paymentWays.push({ code: 2, name: 'Crédito' })
            }

            this.allowEdit()
            
            this.$Progress.finish()

        })
        .catch(e => {
            console.log(e)
            if(e.response.status == 404){
              this.$router.push({ name: "packages"})
              this.$vs.notify({title:'Error!',text:'El paquete no fue encontrado.',color:'danger',icon:'error_outline'})
            }else{
              this.$vs.notify({title:'Error!',text:'Error obteniendo los datos del paquete!',color:'danger',icon:'error_outline'})
            }
        });
    },
    checkWidthScreen () {
      if (this.windowWidth < 641) {
        this.portrait = true
      }else{      
        this.portrait = false   
      }
    },
    validateFirstStep(){
        return new Promise((resolve, reject) => {
            console.log(resolve, reject);
            console.log('is.$v.pack.tracking.$invalid', this.$v.$invalid)
            this.$v.$touch();   
            
            this.$v.pack.tracking.$touch(); this.$v.pack.guide.$touch();
            this.$v.pack.tax.$touch();    
            this.$v.pack.weight.$touch();   this.$v.pack.price.$touch();   
                            
            if (!this.$v.pack.tracking.$invalid && !this.$v.pack.guide.$invalid &&
                !this.$v.pack.tax.$invalid && !this.$v.pack.weight.$invalid && !this.$v.pack.price.$invalid) {
           
                this.calculator();
                resolve(true);
            }else{
                console.log('NO')
                resolve(false);
            }
        })  
    },  
    validStepTwoForm(){
        return new Promise((resolve, reject) => {
            console.log(resolve, reject);
            this.$v.pack.resource.$touch();
            this.$v.pack.delivery.$touch();   
                            
            if (!this.$v.pack.resource.$invalid && !this.$v.pack.delivery.$invalid) {
                this.calculator();
                resolve(true);
            }else{
                console.log('NO')
                resolve(false);
            }            
            // this.calculator();
            // resolve(true);
        })        
    },
    calculator(){
        console.log('CALCULADORA')
        const that = this
        PackageDataService.calculatorRate(this.pack)
        .then(response => {
          this.costs = response.data.result
          this.totalTax = parseFloat(this.costs[1].amount) + parseFloat(this.costs[2].amount)
          if(this.pack.tax.permission){
              this.totalTax = this.totalTax - parseFloat(this.pack.tax.permissionCost)
          }
          this.getTotalPayment()
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error generando los costos!',color:'danger',icon:'error_outline'})                
        });
    }, 
    getTotalPayment(){
        if(this.costs.length > 0){
            this.totalCost = parseFloat(this.costs[0].amount) + parseFloat(this.costs[1].amount) + parseFloat(this.costs[2].amount)
        }
    },
    retrieveTaxes() {
        TaxDataService.getAll()
        .then(response => {
            this.products = response.data;
            this.$Progress.finish()
        })
        .catch(e => {
            console.log(e);
            this.$Progress.finish()
            this.$vs.notify({title:'Error!',text:'Error obteniendo los productos',color:'danger',icon:'error_outline'})
        });
    },
    updatePackageCost(){
        const that = this
        that.loadingProgress ('#btnPaid', '#1a426d')
        that.confirmStatus = true
        this.pack.otherCost  = this.objPack.detail[3] != undefined ? this.objPack.detail[3].amount : 0  
        this.pack.otherTaxes = this.objPack.detail[4] != undefined ? this.objPack.detail[4].amount : 0            
        PackageDataService.updatePackageCost(this.pack)
        .then(response => {
            console.log(response)
            that.confirmStatus = false
            that.$vs.loading.close('#btnPaid .con-vs-loading')
            that.ModalActive = false
            
            this.objPack.package.unit   = {code: response.data.obj.package[0].unit, name: "Libras"}
            this.objPack.package.tax    = response.data.obj.package[0].tax
            this.objPack.package.tracking = response.data.obj.package[0].tracking
            this.objPack.package.guide  = response.data.obj.package[0].guide
            this.objPack.package.price  = response.data.obj.package[0].price
            this.objPack.package.weight = response.data.obj.package[0].weight
            this.objPack.detail         = response.data.obj.detail
            this.objPack.package.comments = this.pack.comments
            this.objPack.package.url      = this.pack.resource
            this.getTotalPayment();
            console.log(this.totalCost)
            console.log(this.pack.otherTaxes)
            console.log(this.pack.otherCost)
            this.objPack.package.costototal =  parseFloat(this.totalCost) + parseFloat(this.pack.otherTaxes)  + parseFloat(this.pack.otherCost)
            that.$vs.notify({title:'Información!',text:'El paquete fue actualizado exitosamente!',color:'success',icon:'check'})
            this.$refs.wizard.reset();  
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error generando los costos!',color:'danger',icon:'error_outline'})                
        });
    }, 
    retrieveStatus() {
        PackageDataService.getStatusAvailables()
        .then(response => {
          this.statusPackages = response.data;
        })
        .catch(e => {
          console.log(e)
          this.$vs.notify({title:'Error!',text:'Error obteniendo los estados!',color:'danger',icon:'error_outline'})
        });
    },
    closedModalNote(){
      this.activeNewNote = false
      this.notes = ''
    },
    createNewNote(){
        let objNote = { 
            id: this.objPack.package.id,
            note: this.notes,
            notify: this.notifyNote ==  true ? 1 : 0
        }
        this.buttonsHidden = true
        PackageDataService.createNote(objNote)
        .then(response => {
            console.log(response)
            this.objPack.notes.push(response.data.obj)
            this.notes = ''
            this.notify = false
            this.activeNewNote = false
            this.buttonsHidden = false
            this.$vs.notify({title:'Información!',text:'La nota fue creada exitosamente!',color:'success',icon:'check'})
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.confirmStatus = false
            this.$vs.notify({title:'Información!',text:'Error creando la nota!',color:'danger',icon:'error_outline'})                
        });

    },
    deletePackageDialog(){
        this.$vs.dialog({
            type:'confirm',
            title: `¡Atención!`,
            color:'',
            cancelText: 'No',
            acceptText: 'Si',
            iconPack:'home',
            text: '¿Estas seguro de eliminar la preAlerta?',
            accept:this.acceptDeletePackage
        })
    },
    acceptDeletePackage(){
        this.pack.status.id = "0"
        PackageDataService.updateStatus(this.pack)
        .then(() => {
            this.confirmStatus = false
            this.$vs.loading.close('#btnConfirm .con-vs-loading')
            this.$vs.notify({title:'Información',text:'El paquete fue eliminado exitosamente.',color:'success',icon:'check'})
            this.$router.push({ name: "packages"})
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.confirmStatus = false
            this.$vs.notify({title:'Información!',text:'Error eliminando el paquete',color:'danger',icon:'error_outline'})                
        });
    },
    updateOtherCosts(){
        this.buttonsHidden = true
        this.otherTaxes = this.objPack.detail[4] != undefined ? this.objPack.detail[4].amount : 0
        this.otherCost  = this.objPack.detail[3] != undefined ? this.objPack.detail[3].amount : 0
       
        if(this.typeOtherAction == 4) {  this.otherCost  = this.tempCost }
        if(this.typeOtherAction == 5) {  this.otherTaxes = this.tempCost }
        
        this.typeOtherAction == 4 ? this.otherCost  : this.otherTaxes
        let obj = {
            "tracking": this.objPack.package.tracking,
            "guide":    this.objPack.package.guide,
            "weight":   parseFloat(this.objPack.package.weight), 
            "price":     parseFloat(this.objPack.package.price),
            "otherCost": parseFloat(this.otherCost), 
            "otherTaxes": parseFloat(this.otherTaxes),
            "tax" : this.objPack.tax,
            "id" : parseFloat(this.objPack.package.id),
            "customerId" : this.objPack.package.cu01Id,
            "unit" : {"code" : this.objPack.package.unit}
        }
        console.log('JOSUE  ', obj);
        PackageDataService.updatePackageCost(obj)
        .then(response => {
            console.log(response)
            console.log('** JOSUE **')
            this.objPack.package.costototal = this.formatNumber(response.data.obj.newAmount)
            this.objPack.detail[this.typeOtherAction - 1].amount   =  this.typeOtherAction == 4 ? this.otherCost : this.otherTaxes
            this.otherCost     = 0
            this.otherTaxes    = 0
            this.tempCost      = 0
            this.activeOtherCost = false
            this.buttonsHidden   = false
            this.$vs.notify({title:'Información!',text:'El costo administrativo fue actualizado correctamente.',color:'success',icon:'check'})
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.confirmStatus = false
            this.$vs.notify({title:'Información!',text:'Error actualizando los costos adminsitrativos.',color:'danger',icon:'error_outline'})                
        });
    },
    closedModalCost(){
      this.activeOtherCost = false
      this.tempCost   = 0
      this.otherCost  = 0
      this.otherTaxes = 0
      this.typeOtherAction = 0
    },
    openCostoModal(currentCost, _type){
        this.tempCost = currentCost
        this.typeOtherAction = _type
        this.activeOtherCost = true; 
    },
    changePrealerted(){
        
        PackageDataService.statusPreAlert({id: this.objPack.package.id, status: this.preAlerted == true ? 1 : 0 })
        .then(() => {
        })
        .catch( () => {
        });
        
    },
    changeFollowUp(){
        
        PackageDataService.statusFollowUp({id: this.objPack.package.id, status: this.followUp == true ? 1 : 0 })
        .then(() => {
        })
        .catch( () => {
        });
        
    },
    closeModalResource () {
       this.pack.resource = this.resourceSelected.url+"?v="+this.getRandomNumber();
        this.popupActivo4 = false
    },
    findResource(_id){
      let found = this.resources.filter((item) => {
        return  _id === item.id
      })
      if( found.length > 0) {
        this.resourceSelected = found[0]
      }
    },
    removeResource(){
       this.pack.resource = ""
    },
    checkExtension(_url){
        if(this.isPdf(_url)){
           return require('@/assets/images/pdf_icon.png')
        }else{
           return _url
        }
    },
    editNote(idx) {
        this.idxUpdateNote = idx
        this.objNote = Object.assign({},this.objPack.notes[idx])
        this.showEditModal = true    
    },
    saveEditNote() {
        this.statusEditNote = true
        PackageDataService.updateNote(this.objNote)
        .then(response => {
            console.log(response)
            this.objPack.notes[this.idxUpdateNote] =  Object.assign({}, this.objNote)
            this.statusEditNote = false
            this.showEditModal = false
            this.key++
            this.$vs.notify({title:'Información!',text:'La nota fue actualizada exitosamente!',color:'success',icon:'check'})
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.statusEditNote = false
            this.$vs.notify({title:'Información!',text:'Error actualizando la nota!',color:'danger',icon:'error_outline'})                
        });
    },
    removeNote(idx) {
        this.idxUpdateNote = idx
         this.$vs.dialog({
            type:'confirm',
            title: `¡Atención!`,
            color:'',
            cancelText: 'No',
            acceptText: 'Si',
            iconPack:'home',
            text: '¿Estas seguro de eliminar la nota?',
            accept:this.acceptDeleteNote
        })
    },
    acceptDeleteNote () {
        this.objNote = this.objPack.notes[this.idxUpdateNote]
        this.objNote.st01Code = 2
        PackageDataService.updateNote(this.objNote)
        .then(response => {
            console.log(response)
            this.objPack.notes.splice(this.idxUpdateNote,1)
            this.key++
            this.$vs.notify({title:'Información!',text:'La nota fue eliminada correctamente!',color:'success',icon:'check'})
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.$vs.notify({title:'Información!',text:'Error eliminando la nota!',color:'danger',icon:'error_outline'})                
        });
    }
    
    
  }
}
</script>